<template>
  <v-layout column>
    <kernel-package-return-info
      :loading="isLoading"
      :loading-error="loadingError"
    />

    <kernel-package-return-items
      :loading="isLoading"
      :loading-error="loadingError"
    />

    <kernel-package-return-history
      :loading="isLoading"
      :loading-error="loadingError"
    />
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import {
  namespace as PackageReturnsNamespace,
  ActionTypes as PackageReturnsActionTypes,
} from '../store.types';

import KernelPackageReturnInfo from '../_components/KernelPackageReturnInfo.vue';
import KernelPackageReturnItems from '../_components/KernelPackageReturnItems.vue';
import KernelPackageReturnHistory from '../_components/KernelPackageReturnHistory.vue';

const dataLoadingOptions = {
  getterName: PackageReturnsActionTypes.GET_PACKAGE_RETURN,
  parameterize: true,
  searchable: false,
  paged: false,
};

export default {
  name: 'KernelPackageReturns',

  components: {
    KernelPackageReturnInfo,
    KernelPackageReturnItems,
    KernelPackageReturnHistory,
  },

  mixins: [
    useDataLoading(dataLoadingOptions),
  ],

  methods: {
    ...mapActions(PackageReturnsNamespace, [PackageReturnsActionTypes.GET_PACKAGE_RETURN]),
  },
};
</script>
